import React from "react";
import PropTypes from "prop-types";
import { Box, Fade } from "@mui/material";
import EMPLoader from "../../shared/components/EMPLoader/EMPLoader";

const StripeOnboardingLoadingState = ({ isExitingStripe, testId }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "310px",
      p: 4,
    }}
    data-testid={testId}
  >
    <Fade in timeout={500}>
      <div>
        <EMPLoader
          loadingMessage={
            isExitingStripe
              ? "Updating Stripe status"
              : "Fetching Stripe status"
          }
        />
      </div>
    </Fade>
  </Box>
);

StripeOnboardingLoadingState.propTypes = {
  isExitingStripe: PropTypes.bool,
  testId: PropTypes.string,
};

StripeOnboardingLoadingState.defaultProps = {
  isExitingStripe: false,
  testId: undefined,
};

export default StripeOnboardingLoadingState;
